import { useEffect, useRef } from "react";
import { PulseLoader } from "react-spinners";
import { AiChatRoles } from "../../constants/commonConstants";
import { ICopilotChatProps } from "../../models/common/IChatBot";
import MarkdownRenderer from "../markdownRenderer";

const CopilotChat = ({
  isModalOpen,
  isFullScreen,
  chatHistory,
  loader,
  isBusy,
  isStreaming,
  chatMessage,
  copied,
  onClose,
  onMaximize,
  onChatMessageChange,
  onSend,
  onStop,
  onCopy,
}: ICopilotChatProps) => {
  const chatEndRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    chatEndRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [chatHistory, isBusy]);

  if (!isModalOpen) return null;

  return (
    <div className={`chat chatbot ${isFullScreen ? "chat_fullscreen" : ""}`}>
      <div className="chatbot-header">
        <div className="img">
          <img src="/assets/images/chatbot.svg" alt="" />
          <h6>AI Assist</h6>
        </div>
        <div className="maximize">
          <button onClick={onMaximize} style={{ marginLeft: "10px" }}>
            <img src="/assets/images/icon/ico-maximise.svg" alt="" />
          </button>
          <button onClick={onClose} style={{ marginLeft: "10px" }}>
            <img src="/assets/images/icon/ico-chat-close.svg" alt="" />
          </button>
        </div>
      </div>

      <div className="chat_body chat_login">
        <div className="intro">
          {chatHistory.map(
            (chat, index) =>
              chat.content && (
                <div key={index} style={{ marginBottom: "12px" }}>
                  <div
                    className={`message-${chat.role} ${
                      chat.content === "Limit exceeded" ? "limit-exceeded" : ""
                    } mb-2`}
                  >
                    <MarkdownRenderer content={chat.content} />
                  </div>
                  <div
                    className={`d-flex justify-content-${
                      chat.role === AiChatRoles.ASSISTANT ? "start" : "end"
                    }`}
                  >
                    <button
                      title="Copy text"
                      onClick={() => onCopy(chat.content)}
                      className={`copy-btn bg-transparent border-0 text-secondary small mt-1 p-0 ${
                        chat.role === AiChatRoles.ASSISTANT ? "ms-5" : "me-5"
                      } mb-2`}
                    >
                      <i className={`fas ${copied ? "fa-check" : "fa-copy"} me-1`} />
                    </button>
                  </div>
                </div>
              ),
          )}

          {loader && (
            <div style={{ marginBottom: "12px" }}>
              <div className="message-assistant p-3 rounded mb-2">
                <PulseLoader color="#948256" size={8} margin={3} />
              </div>
            </div>
          )}

          <div ref={chatEndRef} />
        </div>
      </div>

      <div className="fab_field chatfield">
        <textarea
          placeholder="Message Andy..."
          className="auto-resize-textarea"
          disabled={isBusy}
          value={chatMessage}
          onChange={(e) => onChatMessageChange(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === "Enter" && !e.shiftKey) {
              e.preventDefault();
              onSend();
            }
          }}
        />

        {isBusy || isStreaming ? (
          <button
            type="button"
            onClick={onStop}
            className="stop-btn"
            title="Stop generation"
          >
            <i className="fas fa-square" />
          </button>
        ) : (
          <button
            type="button"
            onClick={() => onSend()}
            disabled={!chatMessage.trim() || isBusy}
            title="Send message"
          />
        )}
      </div>
    </div>
  );
};

export default CopilotChat;
